export default "__VITE_ASSET__674565de__"